import { render, staticRenderFns } from "./GroupChatVideosReveals.vue?vue&type=template&id=2651b323&"
import script from "./GroupChatVideosReveals.vue?vue&type=script&lang=js&"
export * from "./GroupChatVideosReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports